import React from "react";
import { Box, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StripeProvider from "../../config/StripeProvider";
import StripeCardCheckout from "./StripeCardCheckout";

interface PaymentInformationProps {
  businessInfo: Record<string, string | number | boolean | any>;
  setComponentToDisplay: (selection: string) => void;
  setPaymentMethod: (paymentMethod: Record<string, any | undefined>) => void;
  isBillingSame: boolean;
  setIsBillingSame: (isSame: boolean) => void;
}

const PaymentInformation: React.FC<PaymentInformationProps> = ({
  setComponentToDisplay,
  setPaymentMethod,
  isBillingSame,
  setIsBillingSame,
}) => {
  const theme = useTheme();

  return (
    <Container>
      <Box
        sx={{
          mt: 4,
          p: 3,
          padding: 0,
          marginTop: 0,
          color: theme.palette.primary.main,
        }}
      >
        <StripeProvider>
          <StripeCardCheckout
            setComponentToDisplay={setComponentToDisplay}
            setPaymentMethod={setPaymentMethod}
            isBillingSame={isBillingSame}
            setIsBillingSame={setIsBillingSame}
          />
        </StripeProvider>
      </Box>
    </Container>
  );
};

export default PaymentInformation;
